import React from 'react';
import { motion } from 'framer-motion';
import { Star, Users } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const TestimonialSection = () => {
  return (
    <section className="py-16 bg-gray-50 border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center">
          <Badge className="mb-4 bg-green-50 text-green-700 border-green-200">
            Why Choose Munger
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            A Better Way to Do Cold Email
          </h2>
          <p className="text-lg text-gray-600 mb-12">
            Stop managing tools. Start booking meetings.
          </p>

          {/* Key Benefits */}
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="bg-white rounded-xl p-6 shadow-md border border-gray-100"
            >
              <div className="text-blue-600 text-4xl font-bold mb-3">2 min</div>
              <h3 className="font-semibold text-gray-900 mb-2">Setup Time</h3>
              <p className="text-gray-600 text-sm">
                Just fill out a product brief. We handle domains, mailboxes, and campaigns.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="bg-white rounded-xl p-6 shadow-md border border-gray-100"
            >
              <div className="text-green-600 text-4xl font-bold mb-3">90%</div>
              <h3 className="font-semibold text-gray-900 mb-2">Automated</h3>
              <p className="text-gray-600 text-sm">
                Set it once and let it run. No daily management or manual work needed.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="bg-white rounded-xl p-6 shadow-md border border-gray-100"
            >
              <div className="text-purple-600 text-4xl font-bold mb-3">50,000</div>
              <h3 className="font-semibold text-gray-900 mb-2">Meetings Booked</h3>
              <p className="text-gray-600 text-sm">
                AI finds prospects, writes emails, and books qualified meetings on your calendar.
              </p>
            </motion.div>
          </div>

          {/* Simple CTA */}
          <div className="mt-12">
            <p className="text-gray-600 mb-4">
              <Users className="w-4 h-4 inline mr-2" />
              Join companies already using Munger to automate their outbound
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection; 